import React, { Component } from 'react';

import { connect } from 'react-redux';

import { RootState } from '../../../store/rootReducer';

interface Props {
  foregroundColor: string;
}

const OPACITY = 35;

class ConjointExperimentStyleBase extends Component<Props> {
  render() {
    const { foregroundColor } = this.props;

    return (
      <style type="text/css" scoped>
        {`
          .conjoint-radio-button {
            .ant-radio-wrapper {
              .ant-radio:hover .ant-radio-inner {
                border-color: ${foregroundColor};
              }
              .ant-radio-input:focus + .ant-radio-inner {
                border-color: ${foregroundColor};
              }
          
              &.ant-radio-wrapper-checked {
                .ant-radio-inner {
                  border-color: ${foregroundColor};
                  &::after {
                    background-color: ${foregroundColor};
                  }
                }
              }
            }
          }
          .conjoint-card-selected {
            background-color: ${`${foregroundColor}${OPACITY}`};
            border: 3px solid ${foregroundColor};

            .conjoint-box-no-name {
              background-color: ${`${foregroundColor}${OPACITY}`};
            }
          }
          .conjoint-action-wrapper-selected {
            background-color: ${`${foregroundColor}${OPACITY}`};
          }
          .conjoint-action-wrapper-hovered {
            border-left: 3px solid ${foregroundColor};
            border-right: 3px solid ${foregroundColor};
          
            &.conjoint-action-wrapper-first {
              border-top: 3px solid ${foregroundColor};
            }
          }
          .conjoint-action-wrapper-button {

            &.conjoint-action-wrapper-selected,
            &.conjoint-action-wrapper-hovered {
              background-color: ${`${foregroundColor}${OPACITY}`};
            }
                      
            &.conjoint-action-wrapper-hovered {
              border-left: 3px solid ${foregroundColor};
              border-right: 3px solid ${foregroundColor};
          
              &.conjoint-action-wrapper-first {
                border-bottom: 3px solid ${foregroundColor};
              }
            }
          }
        `}
      </style>
    );
  }
}

const mapStateToProps = (state: RootState) => {
  const { foregroundColor } = state.customization ?? {};
  return {
    foregroundColor,
  };
};

export const ConjointExperimentStyle = connect(mapStateToProps)(ConjointExperimentStyleBase);
